export default "__VITE_ASSET__CRz5xdvF__"